<template>
  <div class="row align-items-center">
    <div class="col-sm-6 order-sm-6 text-right font-weight-bold">
      <span class="mr-3" v-if="isDevEnv">[DEVELOPMENT]</span>
      <span class="mr-3" v-if="isStagingEnv">[STAGING]</span>
      <router-link tag="a" :to="{ name: 'Subscription' }" class="icon-right icon-account-black">{{ userName }}</router-link>
    </div>
    <div class="col-sm-6">
      <h1>{{ text }}</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Navbar",
  props: ["text"],
  computed: {
    isDevEnv() {
      return isConfigEnv("development");
    },
    isStagingEnv() {
      return isConfigEnv("staging");
    },
    ...mapGetters([ "userName" ]),
  },
};

function isConfigEnv(name) {
  return process.env.VUE_APP_CONFIG_ENV === name;
}
</script>
